<bn-care-plan-editor-shell
  headingId="option-editor-dialog-title"
  [heading]="mode === 'add' ? 'Add option' : 'Edit option'"
>
  <div carePlanEditorTitle class="bn-option-editor__title-field">
    <label for="option-title" class="bn-option-editor__label">
      Option title <span aria-hidden="true">*</span>
    </label>
    <p-autoComplete
      class="bn-option-editor__title-control"
      inputId="option-title"
      [suggestions]="suggestions()"
      optionLabel="title"
      dataKey="id"
      appendTo="body"
      [minQueryLength]="1"
      [fluid]="true"
      [autoHighlight]="true"
      [forceSelection]="!allowCustomTitle"
      [ngModel]="titleValue()"
      (ngModelChange)="onTitleChange($event)"
      (completeMethod)="searchTitles($event)"
      (onSelect)="onTitleSelect($event)"
      placeholder="Type the option — e.g. Apply for rental assistance"
    />
    @if (titleError(); as error) {
      <p class="bn-option-editor__error m-0" role="alert">{{ error }}</p>
    }
    <div class="bn-option-editor__description-field">
      <label for="option-description" class="bn-option-editor__label">
        Option description <span>(optional)</span>
      </label>
      <textarea
        id="option-description"
        pTextarea
        rows="3"
        maxlength="501"
        [ngModel]="description()"
        (ngModelChange)="description.set($event)"
        placeholder="What it involves and why it fits this client"
      ></textarea>
      @if (description().length > 450) {
        <span class="bn-option-editor__count"
          >{{ description().length }}/500</span
        >
      }
      @if (descriptionError(); as error) {
        <p class="bn-option-editor__error m-0" role="alert">{{ error }}</p>
      }
    </div>
  </div>

  <div carePlanEditorMetadata class="bn-option-editor__metadata-content">
    <bn-care-plan-editor-row
      icon="pi-align-left"
      label="Option type"
      inputId="option-type"
    >
      <p-select
        class="bn-option-editor__select"
        inputId="option-type"
        [options]="optionTypes()"
        optionLabel="label"
        optionValue="code"
        appendTo="body"
        placeholder="Choose an option type"
        [fluid]="true"
        [disabled]="typeLocked()"
        [ngModel]="optionTypeCode()"
        (ngModelChange)="optionTypeCode.set($event)"
      />
      @if (typeError(); as error) {
        <p
          carePlanEditorError
          class="bn-option-editor__meta-error"
          role="alert"
        >
          {{ error }}
        </p>
      }
    </bn-care-plan-editor-row>

    <bn-care-plan-editor-row
      icon="pi-check-circle"
      label="Status"
      inputId="option-status"
    >
      <p-select
        class="bn-option-editor__select"
        inputId="option-status"
        [options]="statusOptions()"
        optionLabel="label"
        optionValue="code"
        appendTo="body"
        [fluid]="true"
        [placeholder]="store.statusLabel(statusCode())"
        [ngModel]="statusCode()"
        (ngModelChange)="statusCode.set($event)"
      >
        <ng-template #selectedItem let-selectedOption>
          {{ selectedOption?.label || store.statusLabel(statusCode()) }}
        </ng-template>
      </p-select>
    </bn-care-plan-editor-row>
  </div>

  @if (requiresNaviQualification()) {
    <p class="bn-option-editor__qualification-warning" role="status">
      Additional criteria must be reviewed with Navi
    </p>
  } @else if (canOverrideQualification() && overrideQualification()) {
    <p class="bn-option-editor__override-advisory" role="status">
      Override on — Still a best practice to check with Navi for eligibility
      criteria
    </p>
  }

  @if (canOverrideQualification()) {
    <div class="bn-option-editor__override-row">
      <label for="option-qualification-override">Override</label>
      <p-toggleswitch
        inputId="option-qualification-override"
        [ngModel]="overrideQualification()"
        (ngModelChange)="overrideQualification.set($event)"
        [disabled]="saving()"
      />
    </div>
  }

  <div carePlanEditorFooter class="bn-option-editor__footer-content">
    <button
      type="button"
      class="bn-option-editor__cancel"
      [disabled]="saving()"
      (click)="tryClose()"
    >
      Cancel
    </button>
    <p-button
      [rounded]="true"
      [label]="submitLabel()"
      [loading]="saving()"
      [disabled]="saving()"
      (onClick)="submit()"
    />
  </div>
</bn-care-plan-editor-shell>

<p-confirmDialog />
